import React, { useState } from 'react';
import Icon from '../Icon';

const BenefitsSplit = ({ onCTA }) => {
  const [tab, setTab] = useState('caregiver');
  const items = tab === 'caregiver' ? [
    { icon: 'dollar',   title: 'Get paid for what you already do',
      body: 'Earn $2,000–$4,500 / month for caregiving you\'d be doing anyway.' },
    { icon: 'shield',   title: 'Keep your health insurance',
      body: "Most state programs let you stay on the recipient's plan or qualify you for your own coverage." },
    { icon: 'clock',    title: 'Flexible hours, no boss',
      body: 'Work the hours that fit your loved one\'s needs and your life. You set the schedule.' },
    { icon: 'document', title: 'No experience required',
      body: 'You don\'t need a CNA license. The state pays family members to do this work.' },
  ] : [
    { icon: 'heart',    title: 'Stay home with family',
      body: 'No nursing home. No stranger in the house. The person they trust most provides care.' },
    { icon: 'compass',  title: 'Care that fits their routine',
      body: 'Bath time at the right hour. Meals they actually like. Routines that calm them.' },
    { icon: 'sun',      title: 'Better outcomes, less stress',
      body: 'Studies show home-based family care leads to fewer hospital visits and better mental health.' },
    { icon: 'phone',    title: 'You stay in the loop',
      body: 'Direct communication with the caregiver — no shift handoffs, no missed updates.' },
  ];

  return (
    <section className="section-benefits" id="benefits">
      <div className="container">
        <div className="section-head center">
          <span className="eyebrow"><Icon name="sparkle" size={12} stroke={2.5}/> Why families choose us</span>
          <h2 className="section-title">
            Built for the <em>caregiver</em> — and the person being cared for.
          </h2>
        </div>

        <div className="benefits-tabs" role="tablist">
          <button className={`tab ${tab === 'caregiver' ? 'active' : ''}`}
            onClick={() => setTab('caregiver')} role="tab">
            <Icon name="heart" size={16} stroke={2.2} /> For caregivers
          </button>
          <button className={`tab ${tab === 'patient' ? 'active' : ''}`}
            onClick={() => setTab('patient')} role="tab">
            <Icon name="sprout" size={16} stroke={2.2} /> For care recipients
          </button>
        </div>

        <div className="benefits-grid fade-up" key={tab}>
          {items.map(it => (
            <div className="benefit-card reveal" key={it.title}>
              <div className="bc-ic"><Icon name={it.icon} size={22} stroke={2}/></div>
              <h4>{it.title}</h4>
              <p>{it.body}</p>
            </div>
          ))}
        </div>

        <div className="benefits-bottom-cta">
          <button className="btn btn-primary btn-md" onClick={onCTA}>
            See if you qualify
            <Icon name="arrow-right" size={16} stroke={2.4} className="arrow"/>
          </button>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSplit;
